<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">{{ $t("main.modalDownloadContractTxt") }}</div>
    <div class="modal-option">
      <dropdown
        :defaultText="$t('main.choose')"
        :selected="lang"
        :list="list"
        :class="{ error }"
        @changeOption="changeOption"
      />
    </div>
    <div class="btn-wrapper ">
      <div @click="ok()" class="btn dark-blue">
        {{ $t("main.confirm") }}
      </div>
      <div @click="closeModal()" class="btn dark-blue outlined">
        {{ $t("main.cancel") }}
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/shared/eventBus.js";
import Dropdown from "@/components/dropdown.vue";
import { api } from "@/api";
export default {
  name: "generateContract",
  components: {
    Dropdown
  },
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      lang: null,
      error: false,
      listE: [
        { id: "en", label: "English" },
        { id: "sr", label: "Serbian" }
      ],
      listS: [
        { id: "en", label: "Engleski" },
        { id: "sr", label: "Srpski" }
      ]
    };
  },
  computed: {
    list() {
      if (this.$route.params.lang === "sr") {
        return this.listS;
      } else {
        return this.listE;
      }
    }
  },
  methods: {
    changeOption(e) {
      this.error = false;
      this.lang = e;
    },
    async ok() {
      if (!this.lang) {
        this.error = true;
        return;
      }
      // this.modalData.ok();
      // eventBus.$emit("closeModal");
      const params = {
        id: this.modalData.off_id,
        lang: this.lang.id
      };
      await api
        .getContract(params)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          // let fileName = response.headers["content-disposition"];
          // console.log(response);
          // fileName = fileName
          //   ? fileName.substring(
          //       fileName.indexOf("filename=") + "filename=".length,
          //       fileName.length
          //     )
          //   : "contract.odt";
          const contentDisposition = response.headers["content-disposition"];
          let filename = "report.odt"; // fallback ako nema headera

          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(
              /filename="?([^"]+)"?/
            );
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1];
            }
          }
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); // naziv fajla
          document.body.appendChild(link);
          link.click();
          eventBus.$emit("refresh");
          eventBus.$emit("closeModal");
        })
        .catch(e => {
          console.log(e);
        });
    },
    closeModal() {
      if (this.modalData.cancel) {
        this.modalData.cancel();
      }
      eventBus.$emit("closeModal");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  min-height: 290px !important;

  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .modal-option {
    text-align: left;
    margin-bottom: 20px;
  }
  .inputs {
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-top: 60px;

    .btn {
      margin-left: 15px;
      border-radius: 10px;
      min-width: 100px;
    }
  }
}
</style>
<style lang="scss">
.dropdown-wrapper.error {
  .header-wrapper {
    border-color: red !important;
  }
}
</style>
